module.exports = __webpack_public_path__ + "static/media/swapcoins_infographic.cab955bd.png";